import CommercialBadge from "Components/CommercialBadge/CommercialBadge";
import { FC, ReactNode } from "react";
import { StyledTitle, TitleWrapper } from "./Title.styled";

interface Props {
  type?: string;
  children?: ReactNode;
  title?: string;
  commercialBadgeImage?: {
    data: { url: string; alt: string | null; title: string | null };
  } | null;
  commercialBadgeTerm?: {
    name: string;
    url: string | null;
    id: number;
    uuid: string;
    bundle: string;
  } | null;
  commercialBadgeLink?: string | null;
}

const Title: FC<Props> = ({
  type = "default",
  title,
  children,
  commercialBadgeImage,
  commercialBadgeTerm,
  commercialBadgeLink,
}) => {
  return (
    <TitleWrapper>
      <StyledTitle type={type}>{title || children}</StyledTitle>

      <CommercialBadge
        image={commercialBadgeImage}
        term={commercialBadgeTerm}
        link={commercialBadgeLink}
      />
    </TitleWrapper>
  );
};

export default Title;
